import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { getRequirements, submitInstitutionForApproval, setTenant } from '../../../reducers/tenants';
import { Snackbar } from '../../../components/snackbar';
import { DocTableHeader } from '../common';
import Document from './../../../components/document';
import { DocumentInfo, PERMISSIONS } from '../../../utilities/documentTypes';
import messages from '../../../text/messages';

import './../documents.css';

class AdminDocuments extends React.Component {
    constructor(props) {
        super(props);

        this.getDocumentRequirements = this.getDocumentRequirements.bind(this);
        this.onDocumentUploaded = this.onDocumentUploaded.bind(this);
    }

    getDocumentRequirements() {
        const { requirements } = this.props;
        return requirements ? requirements.filter(r => r.entity === 'doc') : undefined;
    }

    onDocumentUploaded() {
        const { role, details, getRequirements, submitInstitutionForApproval, setTenant, externalOnCompleteCallback } = this.props;

        getRequirements(role, result => {
            if (result.filter(r => r.entity_has === r.entity_min).length === result.length && details.status !== 'active') {
                submitInstitutionForApproval(role, () => {
                    setTenant(role);
                    Snackbar.success(<FormattedMessage id={'documents.adminUploadComplete'} defaultMessage={'Required documents uploaded'} />);
                    if (externalOnCompleteCallback) {
                        externalOnCompleteCallback();
                    }
                });
            }
        });
    }

    render() {
        const requirements = this.getDocumentRequirements();
        const uploaded = requirements.filter(r => r.entity_has === r.entity_min).length;
        const total = requirements.length;
        const uploadStatus = uploaded !== total ? { uploaded: uploaded, total: total } : undefined;

        return (
            <div>
                <div className="row section">
                    <div className="col-xs-8">
                        <FormattedMessage id={'documents.globalUpload'} defaultMessage={'Upload global documents for use by clients and workers.'} />
                    </div>
                    {uploadStatus && (
                        <div className="col-xs-4 text-right">
                            <FormattedMessage id={'documents.adminRequirements'} defaultMessage={'{uploaded}/{total} documents'} values={uploadStatus} />
                        </div>
                    )}
                </div>
                <div className="row">
                    <DocTableHeader />
                </div>

                <div className="manage-documents">
                    <div className="row section">
                        <div className="col-xs-12">
                            {DocumentInfo.adminListableDocuments.map((doc, i) => (
                                <div className="color-2" key={i}>
                                    <Document
                                        id={`${doc.docType}${i}`}
                                        upload={{
                                            button: onOpen => (
                                                <div className="table-row">
                                                    <div className="row">
                                                        <div className="col-xs-12">
                                                            <div className="col-xs-8 column-name ellipsis">
                                                                <FormattedMessage {...messages.upload} /> {doc.displayName}
                                                            </div>
                                                            <div className="col-xs-4 text-right">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={onOpen}>
                                                                    <FormattedMessage {...messages.upload} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                            limit: doc.limit,
                                            permissions: PERMISSIONS.DEFAULT,
                                            onUploaded: this.onDocumentUploaded
                                        }}
                                        {...doc}
                                        view={{ showHeader: false }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Document id={'all-documents'} docType={''} excludeDocTypes={DocumentInfo.adminListableDocuments.map(d => d.docType)} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    role: state.identity.role,
    details: state.identity.details,
    requirements: state.tenants.requirements
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getRequirements: getRequirements,
            submitInstitutionForApproval: submitInstitutionForApproval,
            setTenant: setTenant
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AdminDocuments);



// WEBPACK FOOTER //
// ./src/pages/documents/tenants/admin.jsx